import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {  PolicyManualContent, ContractDetails } from '../Models/common.model'

@Injectable({
  providedIn: 'root'
})
export class ContractSearchService {
    private apiURL = window.location.href;

    private searchString = new BehaviorSubject<string>(null);
    getSearchstring$ = this.searchString.asObservable();

    modifyString(searchText: string): void {
        this.searchString.next(searchText);
    }

    private findPosition = new BehaviorSubject<number>(null);
    getPosition$ = this.findPosition.asObservable();

    setPosition(position: number): void {
        this.findPosition.next(position);
    }

    private totalSearchCount = new BehaviorSubject<number>(null);
    getTotalSearchCount$ = this.totalSearchCount.asObservable();

    setTotalSearchCount(count: number): void {
        this.totalSearchCount.next(count);
    }

    private currentPosition = new BehaviorSubject<number>(null);
    getCurrentPosition$ = this.currentPosition.asObservable();

    setCurrentPosition(count: number): void {
        this.currentPosition.next(count);
    }

    private expandSection = new BehaviorSubject<boolean>(null);
    getExpandValue$ = this.expandSection.asObservable();

    setExpandValue(value: boolean): void {
        this.expandSection.next(value);
    }

    private contractAdminLink = new BehaviorSubject<string>(null);
    getContractAdminLink$ = this.contractAdminLink.asObservable();

    setContractAdminLink(value: string): void {
        this.contractAdminLink.next(value);
    }

    private contractAdminLinkText = new BehaviorSubject<string>(null);
    getContractAdminLinkText$ = this.contractAdminLinkText.asObservable();

    setContractAdminLinkText(value: string): void {
        this.contractAdminLinkText.next(value);
    }

    private searchTextPlaceholder = new BehaviorSubject<string>(null);
    getSearchTextPlaceholder$ = this.searchTextPlaceholder.asObservable();

    setSearchTextPlaceholder(value: string): void {
        this.searchTextPlaceholder.next(value);
    }

    private toggleEvent = new BehaviorSubject<any>(null);
    getToggleEvent$ = this.toggleEvent.asObservable();

    setToggleEvent(value: any): void {
        this.toggleEvent.next(value);
    }

    private qstringSectId = new BehaviorSubject<any>(null);
    getQstringSectId$ = this.qstringSectId.asObservable();

    setQstringSectId(value: any): void {
        this.qstringSectId.next(value);
    }

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    }

    constructor(private http: HttpClient) {
    }

    getContractDetails(): Observable<ContractDetails>{
        var backToTopstring = this.apiURL.indexOf('#');
        if (backToTopstring != -1) {
            this.apiURL = this.apiURL.substring(0, backToTopstring);
        }
        var queryString = this.apiURL.indexOf('?');
        if (queryString != -1) {
            this.setQstringSectId(this.apiURL.substring(this.apiURL.indexOf('=') + 1, this.apiURL.length))
            this.apiURL = this.apiURL = this.apiURL.substring(0, queryString);
        }
        return this.http.get<ContractDetails>(this.apiURL + '/GetContractJson/')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getPolicyManualContent(): Observable<PolicyManualContent> {
        var backToTopstring = this.apiURL.indexOf('#');
        if (backToTopstring != -1) {
            this.apiURL = this.apiURL.substring(0, backToTopstring);
        }
        return this.http.get<PolicyManualContent>(this.apiURL + '/GetSearchContenInJson/')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
